export default {
  SUPER_ADMIN: 'Super Admin',
  MERCHANT: 'Merchant',
  CUSTOMER: 'Customer',
}
